<template>
	<v-dialog v-model="dialog" max-width="400px">
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">変更履歴</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<h3 class="pa-2">現在のデータ：{{ this.answerValue.value }}</h3>
			<h3 class="pa-2 pt-1">更新日：{{ this.answerValue.updated_at | dateFormatter }}</h3>
			<v-card-text class="pa-2">
				<v-simple-table>
					<template v-slot:default>
						<thead>
							<tr>
								<th class="text-left">作成日</th>
								<th class="text-left">内容</th>
								<th class="text-left">変更理由</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in answerValueFixes" :key="item.name">
								<td>{{ item.created_at | dateFormatter }}</td>
								<td>{{ item.value }}</td>
								<td>{{ item.reason }}</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</v-card-text>
			<v-card-actions>
				<v-row no-gutters> </v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import moment from "moment"
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import FunctionTitle from "../../shared/FunctionTitle.vue"
import CommonFlame from "../../shared/CommonFlame.vue"
// editTargetをVueとRailsで共有する必要あり
export default {
	props: {},
	data() {
		return {
			dialog: false,
			answerValue: {},
			answerValueFixes: [],
			answerValueId: "",
		}
	},
	filters: {
		dateFormatter: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
	},
	methods: {
		openDialog(answerValueId) {
			this.dialog = true
			this.answerValueId = answerValueId
			this.fetchAnswerValue()
		},
		fetchAnswerValue() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/logistics/answer_values/" + this.answerValueId + ".json", { headers })
				.then((res) => {
					this.answerValue = res.data.answer_value
					this.answerValueFixes = res.data.answer_value_fixes
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {},
}
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
	margin-top: 0;
}
</style>
